import { Component, h, Host, Prop, Listen, Element } from '@stencil/core';
import { HTMLStencilElement } from '@stencil/core/internal';
import { BehaviorSubject } from 'rxjs';
// import { A11y, Navigation, Pagination } from 'swiper/modules';

/**
 * @slot content - This slot will usually serve a content hero block or image.
 * @slot - Default slot, same as content slot.
 */
export type InitMethodType = 'load' | 'event';
@Component({
  tag: 'content-carousel',
  styleUrl: 'content-carousel.scss',
  shadow: false,
})
export class ContentCarousel {
  @Element() hostElement: HTMLStencilElement;
  /**
   * @type Select
   * @options load
   * @options init
   */
  @Prop() initMethod: InitMethodType = 'load';
  /**
   * @type JSON
   * @schema Swiper Options
   */
  @Prop() swiperOptions: string = '{"slidesPerView": 1, "slidesPerGroup": 1, "autoplay": true, "loop": false}';
  public swiperCarousel: any;
  public swiper?: HTMLDivElement;
  public swiperWrapper?: HTMLDivElement;
  public swiperPagination?: HTMLDivElement;
  public swiperPrevElement?: HTMLButtonElement;
  public swiperNextElement?: HTMLButtonElement;
  public swiperScrollbar?: HTMLDivElement;
  public swiperOptionsFinal;

  loadStatus: BehaviorSubject<boolean> = new BehaviorSubject(false);

  getSwiperOptions(newOptions: string): object {
    return Object.assign(
      {
        observer: true,
        observeParents: true,
        pagination: {
          el: this.swiperPagination,
        },
        navigation: {
          nextEl: this.swiperNextElement,
          prevEl: this.swiperPrevElement,
        },
        scrollbar: {
          el: this.swiperScrollbar,
        },
      },
      newOptions,
    );
  }
  componentDidLoad() {
    if (this.initMethod === 'load') {
      if (this.swiperOptions) {
        this.swiperOptionsFinal = this.getSwiperOptions(JSON.parse((this.swiperOptions as string) || ''));
      }

      let options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      };

      let observer = new IntersectionObserver(entries => {
        entries.forEach(async entry => {
          if (entry.isIntersecting && !this.loadStatus.getValue()) {
            await this.initSwiper();
            this.loadStatus.next(true);
          }
        });
      }, options);
      observer.observe(this.hostElement);
    }
  }

  @Listen('setSwiperOptions')
  setSwiperOptionsCallback(event: CustomEvent) {
    this.loadStatus.subscribe(async () => {
      let loaded = this.loadStatus.value;
      if (loaded) {
        this.swiperOptionsFinal = this.getSwiperOptions(event.detail);
        await this.initSwiper();
      }
    });
  }

  async initSwiper() {
    let Swiper = await import('swiper');
    let SwiperModules = await import('swiper/modules');

    for (const slide of this.swiperWrapper.children as any) {
      slide.classList.add('swiper-slide');
    }
    // configure Swiper to use modules
    this.swiperCarousel = new Swiper.Swiper(this.swiper, {
      ...this.swiperOptionsFinal,
      ...{
        modules: [SwiperModules.A11y, SwiperModules.Navigation, SwiperModules.Pagination],
      },
    });
  }

  render() {
    return (
      <Host>
        <div class="swiper" ref={el => (this.swiper = el as HTMLDivElement)}>
          <div class="swiper-wrapper" ref={el => (this.swiperWrapper = el as HTMLDivElement)}>
            <slot name="content"></slot>
            <slot></slot>
          </div>
          <div class="swiper-pagination" ref={el => (this.swiperPagination = el as HTMLDivElement)}></div>

          <button class="swiper-button-prev" ref={el => (this.swiperPrevElement = el as HTMLButtonElement)}></button>
          <button class="swiper-button-next" ref={el => (this.swiperNextElement = el as HTMLButtonElement)}></button>

          <div class="swiper-scrollbar" ref={el => (this.swiperScrollbar = el as HTMLDivElement)}></div>
        </div>
      </Host>
    );
  }
}
